import { useState } from 'react'
import { can } from '../../../services/user-utils'
import useUser from '../../../hooks/use-user'
import { Permissions } from '../../../../types/user-types'
import ExternalDocumentReferenceTable from './summary-table'
import { useWellId } from '../../../hooks/use-well-id'
import { useNavigate } from 'react-router-dom'
import { Button, ButtonsContainer, Card, Heading, HeadingRow, RecordContent } from '@msaf/core-react'

export default function ExternalDocumentReferencesWrapper() {
  const { user } = useUser()
  const [fields, setFields] = useState<Array<Record<string, string | number | boolean>> | null>(null)
  const navigate = useNavigate()
  const id = useWellId()

  return (
    <RecordContent>
      <Heading level={2}>External document references</Heading>
      <Card isFullWidth>
        <HeadingRow headingLevel={3} headingText='Summary'>
          {can(user, [Permissions.EDIT_EXTERNAL_DOCUMENTS]) && !!user?.objectPermissions?.canEdit && (
            <ButtonsContainer containerStyle='right'>
              <Button label='Add new' onClick={() => navigate(`/wells/${id}/edit/external-document-references/new`)} />
            </ButtonsContainer>
          )}
        </HeadingRow>
        <ExternalDocumentReferenceTable fields={fields} setFields={setFields} />
      </Card>
    </RecordContent>
  )
}
